var actions = document.getElementById('recruiter-actions');

//Open contact option dropdown
actions.addEventListener('click', function () {
    this.classList.toggle('open');
});

//Close contact option dropdown when click next to it
document.onclick = function (e) {
    if (e.target != actions && e.target.parentNode != actions) {
        actions.classList.remove('open');
    }
};

window.onscroll = function () {
    fixedContactBar();
};

//Set contact bar fixed when reaches to of the screen
var heroElement = document.querySelector('.block_hero_vacancy');
var contactBar = document.querySelector('.block_hero_vacancy .inner-search');
var sticky = contactBar.offsetTop + 72;

function fixedContactBar() {
    if (window.pageYOffset > sticky) {
        contactBar.classList.add('is-sticky');
        heroElement.classList.add('remove-transform');
    } else {
        contactBar.classList.remove('is-sticky');
        heroElement.classList.remove('remove-transform');
    }
}
